import {
  TPersonalDataApplicationDocumentResponse,
  TPersonalDataApplicationsStore,
} from '~/store/processing-personal/types.ts';
import { PayloadAction } from '@reduxjs/toolkit';

export const postApplicationFormFulfilled = (
  state: TPersonalDataApplicationsStore,
  action: PayloadAction<TPersonalDataApplicationDocumentResponse>
) => {
  state.applicationDocumentId = action.payload.applicationDocumentId;

  state.loading = false;
  state.error = null;
  state.status = '';
};

export const postApplicationFormPending = (state: TPersonalDataApplicationsStore) => {
  state.loading = true;
  state.applicationDocumentId = '';
};
